import React from 'react';
import { CarouselConsumer } from '..';
import { type CarouselItemProps } from '../types';
import { StyledCarouselItem } from '../styled';

export const Item = ({ children, position, ...rest }: CarouselItemProps) => {
	return (
		<CarouselConsumer>
			{({ visiblePosition }) => (
				<StyledCarouselItem visiblePosition={visiblePosition} currentPosition={position} {...rest}>
					{children}
				</StyledCarouselItem>
			)}
		</CarouselConsumer>
	);
};
